export const getModalPortal = (): HTMLElement | null => {
  if (typeof document === "undefined" || typeof window === "undefined") {
    return null;
  }

  const modalPortal = document.getElementById("portalContainer");

  return modalPortal;
};
